// @mui
import { Box } from '@mui/material';
// components
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

type Props = {
  onToggleCollapse: VoidFunction;
  collapseClick: boolean;
  icon: React.ReactNode;
  rotation: 'rotate(180deg)',
};

export default function CollapseButton({ onToggleCollapse, collapseClick, icon, rotation }: Props) {
  return (
    <IconButtonAnimate sx={{ p: 0.5 }} onClick={onToggleCollapse}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(collapseClick && {
            transform: 'rotate(180deg)'
          }),
        }}
      >
        {icon}
      </Box>
    </IconButtonAnimate>
  );
}